<div class="training-item clickable">
  <div class="icon folder"></div>
  <div class="name text-color-primary">{{folder.name}}</div>
  <div class="folder-arrow text-color-secondary">
      <i class="fa fa-fw fa-angle-right"></i>
  </div>
</div>